import { UserType } from "../../interfaces/User";

export const getUserColor = (userType: UserType) =>
    userType === UserType.Teacher
        ? "var(--element-teacher-default)"
        : "var(--element-evidenceb-default)";
